export default class Language {
    constructor() {

    }

    preValidateFormFields(id) {
        let translation = '';

        switch (id) {
            case 'gender':
            case 'geslacht':
            case 'state':
                translation = '%s chưa được chọn';
                break;

            case 'firstname':
            case 'lastname':
            case 'voorletter':
            case 'achternaam':
                translation = '%s không được để trống';
                break;

            case 'street':
            case 'housenumber':
            case 'city':
            case 'address':
            case 'straat':
            case 'huisnummer':
            case 'plaats':
                translation = '%s là trường bắt buộc';
                break;

            case 'telephone':
            case 'email':
            case 'heeltelefoonnummer':
            case 'mobile':
            case 'zipcode':
            case 'birthdate':
            case 'bankaccount':
                translation = '%s chưa được điền chính xác';
                break;

            case 'opt-in':
                translation = 'Vui lòng kiểm tra hộp để tiếp tục';
                break;

            default:
                translation = 'Trường này chưa được điền chính xác';
                break;
        }

        return translation;
    }
}
